import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';
import { ListBrands } from '@/interfaces/brands';

class BrandsService {
	constructor(private client: AxiosInstance) {}

	async get(): Promise<HttpResponse<ListBrands>> {
		return this.client.get(`/brands?page=1&limit=100`);
	}
	// this one is will be use while we change where the old one is used
	async getPaginatedBrands(
		search: string,
		page: number,
		limit: number
	): Promise<HttpResponse<ListBrands>> {
		return this.client.get(
			`/brands?page=${page}&limit=${limit}&name=${search}`
		);
	}

	async getClientListByBrand(caseId: string, brandId: string): Promise<any> {
		return this.client.get(`metrics/client-list/excel`, {
			params: { caseId, brandId },
			responseType: 'blob',
		});
	}

	async create(name: string): Promise<HttpResponse<{ message: string }>> {
		return this.client.post('/brands', { name });
	}

	async update(value: string, id: string): Promise<HttpResponse<any>> {
		return this.client.put(`/brands/${id}`, { name: value });
	}

	async delete(id: string): Promise<HttpResponse<any>> {
		return this.client.delete(`/brands/${id}`);
	}
}

export const brandsService = new BrandsService(axiosClient);
